import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Section from '../../section';
import Container from '../../container';
import Subhead from '../../subhead';
import Button from '../../button';
import { Link } from '../../../routes';
import PartnerGrid from '../../partner-grid';
import TextWave from '../../text-wave';

const AboutPartners = props => (
  <PartnerSection id={props.id}>
    <Container>

      <Subhead>{props.subheading}</Subhead>
      <TextWave>
        <h2>{props.title}</h2>
      </TextWave>
      <p>{props.intro}</p>

      <PartnerGrid partnerList={props.partners} />

      <PartnerButton black href="/partners#become-a-partner">
        Become a Partner
      </PartnerButton>

      <Link route="/partners">
        <a>View All</a>
      </Link>

    </Container>
  </PartnerSection>
);

const PartnerSection = styled(Section)`
  text-align: center;

  p {
    max-width: 790px;
    margin: 70px auto 0;

    ${screen.below(bp.tablet, `
      margin: 30px auto 0;
    `)};
  }
`;

const PartnerButton = styled(Button)`
  display: block;
  margin: 126px auto 68px;

  ${screen.below(bp.tablet, `
    width: 100%;
    margin: 64px auto 34px;
  `)};
`;

AboutPartners.propTypes = {
  subheading: PropTypes.string,
  title: PropTypes.string,
  intro: PropTypes.string,
  partners: PropTypes.array,
  id: PropTypes.string,
};

export default AboutPartners;
